import React, { useState, useRef } from 'react';
import { StatOptions } from 'fs';
import { RiderModel, ActionType, RiderStatusType, User, RiderPackageModel, BranchModel, CustomerAddressModel, VehicleDataModel, ManufacturerModel, VehicleModelModel, Riders_PackagesModel, CustomerContactDetailsModel, RiderPackage, CustomerModel } from '../models/superbit-api-models'
import { SubscribersModel } from '../models/SubscribersModel'
import '../assets/css/_new-subscriber-popup.css'
// import {Menu} from '../_Menu'
// import Header from '../Header';
// import {Footer} from '../_Footer'
import moment from 'moment';
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData, filterIDNameDescriptionDictionary } from '../models/Site'
import { SimulatorModel, SimulatorData } from '../models/SimulatorModel'
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DynamicSelect } from '../components/_DynamicSelect'
// import TreeSelect from '../components/_TreeSelect';
import { Autocomplete } from '../components/_Autocomplete';
import VehicleData from "../vehicles/_Vehicle";
import { data, post } from 'jquery';
import { Select, TreeSelect } from 'antd';
import BranchesStationsTree from "../Branches/_branchesStationsTree"
import { devUseWarning } from 'antd/es/_util/warning';
import MessegePopup from './popups/_MessegePopup';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import CustomSearchHandler from '../leads/_CustomSearchHandler';
const { TreeNode } = TreeSelect;


type Props = {
    id: string | undefined;
    customer?: CustomerModel;
    vehicle?: any;
    actionType: ActionType | undefined;
    ClosePopup: any;
    OpenPayment: any;
    rider?: RiderModel | undefined | null;
    setPopupShow?: React.Dispatch<React.SetStateAction<boolean>>
    setMessege?: React.Dispatch<React.SetStateAction<string>>
    setMessageType?: React.Dispatch<React.SetStateAction<string>>
    renewRider?: boolean;
};
type State = {
    data: RiderModel | null;
    usedPackages: RiderPackageModel[];
    Gender: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    AuthorizedToDriveItems: IDNameDescriptionDictionary;
    InsuranceTypes: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    CustomerAgents: IDNameDescriptionDictionary;
    StationUserId: string;
    AgentId: string;
    CustomerHandlers: any[];
    SubscriptionStatuses: IDNameDescriptionDictionary;
    Branches: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    SelectedTab: number;
    RiderStatusType: Array<RiderStatusType>;
    licenseNumber: string;
    editMode: boolean;
    packagesList: IDNameDescriptionDictionary;
    packagesListAll: IDNameDescriptionDictionary;
    packagesListAll2: RiderPackageModel[];
    Branches2: IDNameDescriptionDictionary;
    allCities: any[];
    streetList: [];
    citiesAutocomplete: Array<AutocompleteData>
    streetAutocomplete: Array<AutocompleteData>
    customerDetailsValidation: boolean;
    identifierErrMsg: string;
    packagesErrMsg: string;
    firstNameErrMsg: string;
    lastNameErrMsg: string;
    fullNameErrMsg: string;
    vehicleNumberErrorMsg: string;
    vehicleValidation: boolean;
    phoneErrMsg: string;
    emailErrMsg: string;
    birthdateErrMsg: string;
    startDateErrMsg: string;
    endDateErrMsg: string;
    handlerErrMsg: string;
    cityErrMsg: string;
    postalcodeErrMsg:string;
    streetErrMsg: string;
    houseNumberErrMsg: string;
    createRiderErr: string;
    vehicles: Array<VehicleDataModel> | null;
    vehicleValidationHandler: string;
    treeData: any[];
    treeDataValue: string | null;
    isCompany: boolean;
    NextTabLoading: boolean;
    SaveLoading: boolean;
    PostalLoading:boolean;
    riderPackages: RiderPackagesWithErrors[];
    isInSystem: boolean;
    popupShow: boolean;
    position: any;
    isDragging: boolean;
    offset: any;
    CustomerHandlersOld: any[];

};
// AuthorizedToDriveItems

class RiderPackagesWithErrors {
    package: Riders_PackagesModel;
    showDescription: boolean;
    errors: {
        customerCostErrorMsg?: string;

    };


    constructor(p: Riders_PackagesModel) {
        // 
        this.package = p;
        this.errors = {};
        this.showDescription = false;
    }
}

export class SubscriberPopup extends React.Component<Props> {

    private birthDateRef: React.RefObject<DatePicker>;
    private subscriptionStartDateRef: React.RefObject<DatePicker>;
    private subscriptionEndDateRef: React.RefObject<DatePicker>;
    simulatorModel: SimulatorModel;
    //childRef = useRef<ChildRef>(null);

    state: State = {
        data: null,
        usedPackages: [],
        Gender: new IDNameDescriptionDictionary(),
        IdentityTypes: new IDNameDescriptionDictionary(),
        VehicleOwnership: new IDNameDescriptionDictionary(),
        AuthorizedToDriveItems: new IDNameDescriptionDictionary(),
        InsuranceTypes: new IDNameDescriptionDictionary(),
        MaritalStatus: new IDNameDescriptionDictionary(),
        CustomerAgents: new IDNameDescriptionDictionary(),
        CustomerHandlers: [],
        SubscriptionStatuses: new IDNameDescriptionDictionary(),
        Branches: new IDNameDescriptionDictionary(),
        CarYear: [],
        SelectedTab: 1,
        RiderStatusType: [],
        licenseNumber: '',
        editMode: false,
        packagesList: new IDNameDescriptionDictionary(),
        packagesListAll: new IDNameDescriptionDictionary(),
        packagesListAll2: [],
        Branches2: new IDNameDescriptionDictionary(),
        StationUserId: '',
        AgentId: '',
        allCities: [],
        streetList: [],
        citiesAutocomplete: [],
        streetAutocomplete: [],
        customerDetailsValidation: false,
        identifierErrMsg: "",
        firstNameErrMsg: "",
        lastNameErrMsg: "",
        fullNameErrMsg: "",
        vehicleValidation: false,
        phoneErrMsg: "",
        emailErrMsg: "",
        birthdateErrMsg: "",
        startDateErrMsg: "",
        handlerErrMsg: "",
        endDateErrMsg: "",
        cityErrMsg: "",
        postalcodeErrMsg:"",
        streetErrMsg: "",
        houseNumberErrMsg: "",
        vehicleNumberErrorMsg: "",
        createRiderErr: "",
        vehicles: null,
        vehicleValidationHandler: "",
        treeData: [],
        isCompany: false,
        treeDataValue: null,
        NextTabLoading: false,
        SaveLoading: false,
        riderPackages: [],
        packagesErrMsg: "",
        PostalLoading:false,
        isInSystem: false,
        popupShow: false,
        position: { x: 500, y: 30 },
        isDragging: false,
        offset: { x: 0, y: 0 },
        CustomerHandlersOld: []
    };

    constructor(props: any) {
        super(props);
        this.birthDateRef = React.createRef<DatePicker>();
        this.subscriptionStartDateRef = React.createRef<DatePicker>();
        this.subscriptionEndDateRef = React.createRef<DatePicker>();
        this.simulatorModel = new SimulatorModel();
    }





    closePopup = () => {
        this.props.ClosePopup();
        console.log('closePopup')
    }

    saveRider = async () => {
        // 
        if (this.state.SaveLoading == false) {
            this.setState({ SaveLoading: true });
            if (this.riderDetailsValidation()) {
                if (this.state && this.state.data) {

                    console.log(this.state.data, this.state.data.customer);

                    var data = this.state.data;
                    data.createdDate = new Date();
                    data.agents = undefined;
                    data.branches = undefined;
                    data.packages = undefined;
                    data.salesPeople = undefined;
                    data.users = undefined;

                    try {
                        const response = await new SubscribersModel().saveNewRider(data);
                        console.log('await new SubscribersModel().saveNewRider response', response)

                        // 
                        if (response && (response.responseCode == 200 || response.responseCode == 202)) {
                            // 
                            if(this.props.setMessege && this.props.setPopupShow){
                            this.props.setMessege("מנוי הוקם בהצלחה, הנך מועבר לביצוע תשלום");
                            this.props.setPopupShow(true);
                            }
                            // this.setState({ popupShow: true})
                            this.props.OpenPayment(response.rider);
                            // setTimeout(() => {
                            // }, 2000);
                            //open payment popup
                        }else if(response.status == 400){
                            console.log('response', response)
                            let error = response.errors;
                            let errorMessege = error['Vehicle.Customer.CustomerContactDetails[0].Number'][0];
                            console.log('errorMessege', errorMessege)
                            
                            if(this.props.setMessageType && this.props.setMessege && this.props.setPopupShow){
                                this.props.setMessege(errorMessege);
                                this.props.setPopupShow(true);
                                this.props.setMessageType('שגיאה');
                            }
                           
                        } else {

                            this.setState({ createRiderErr: response.responseMessage });

                        }
                    }catch (e: any) {
                        console.log('error', e);
                        // if(this.props.setMessageType && this.props.setMessege && this.props.setPopupShow){
                        //     this.props.setMessege(e.message);
                        //     this.props.setPopupShow(true);
                        //     this.props.setMessageType('שגיאה');
                        // }
                    }
                }

            }
            this.setState({ SaveLoading: false });
        }
    }

    changeCurrentTab = async (num: number) => {
        this.setState({ NextTabLoading: true });
        // 
        switch (num) {
            case 1: 
                if (!this.customerDetailsValidation()) {
                    console.log('changeCurrentTab')

                    this.setState({ NextTabLoading: false }); 
                    return; 
                }
            else {
                if (this.state.data) {
                    var v = this.state.data.vehicle;
                    if (v) {
                        v.manufacturer = undefined;
                        v.vehicleModel = undefined;
                        v.vehicleSubModel = undefined;
                        if (v.carYear == undefined)
                            v.carYear = new Date().getFullYear();
                        var packagesIds = await new SubscribersModel().riderGetPackages(v);

                        //var packages = this.state.packagesList.filter((x:IDNameDescriptionItem)=> packagesIds.includes(x.id));

                        var filteredData = filterIDNameDescriptionDictionary(this.state.packagesListAll, (item) =>
                            item.id &&packagesIds && packagesIds.includes(item.id))

                        // const packagesEntries = Object.entries(this.state.packagesList);
                        // const filteredEntries = packagesEntries.filter(
                        //     ([key, item]: [string, IDNameDescriptionItem]) => item.id && packagesIds.includes(item.id)
                        // );

                        // // Convert the filtered entries back to a dictionary
                        // const filteredPackagesDictionary: IDNameDescriptionDictionary = Object.fromEntries(filteredEntries);

                        // Set the filtered dictionary back to the state
                        this.setState({ packagesList: filteredData });

                    }

                }

            }
                break;
            case -1: {
                var _data = this.state.data;
                if (_data) {
                    _data.riderPackages = [];
                    this.setState({ riderPackages: _data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) });
                    this.setState({ data: _data });
                }



            }
                break;
        }
        let currentTab = this.state.SelectedTab;
        currentTab += num;

        this.setState({
            SelectedTab: currentTab,
            NextTabLoading: false
        });

    }

    componentDidMount() {
        this.load();

        if(this.props.setPopupShow){
            this.renewRiderSubscribe()
        }
    }

    renewRiderSubscribe = () => {
        // const customerData = await this.simulatorModel.getCustomerDetailsById(value);
        // console.log('customerData', customerData);
        // if (customerData && customerData.customer) {

        //     if (stateData && stateData.customer) {
        //         stateData.customer.id = customerData.customer.id;
        //         stateData.customer.identityType = customerData.customer.identityType;
        //         stateData.customer.firstName = customerData.customer.firstName;
        //         stateData.customer.lastName = customerData.customer.lastName;

        //         const bDate = new Date(customerData.customer.dateOfBirth.replace('T', ' '));
        //         stateData.customer.dateOfBirth = bDate;

        //         stateData.customer.gender = customerData.customer.gender;

        //         stateData.customer.customerContactDetails = customerData.customer.customerContactDetails;
        //         stateData.customer.customerAddresses = customerData.customer.customerAddresses;
        //         this.setState({ vehicles: customerData.customer.vehicles, isInSystem: true });

        //         if (customerData.customer.vehicles && customerData.customer.vehicles.length > 0) {
        //             var rider = this.state.data;
        //             if (rider) {
        //                 rider.vehicle = customerData.customer.vehicles[0];
        //                 rider.vehicleId = customerData.customer.vehicles[0].id;

        //                 this.setState({ data: rider });
        //             }
        //         }

        //         this.customerDetailsValidation();
        //     }
        // }
    }

    customerDetailsValidation2() {


        return (this.identifierValidation() && this.firstNameValidation() && this.lastNameValidation() && this.fullNameValidation() && this.state.vehicleValidation && this.phoneValidation() && this.emailValidation() && this.birthdateValidation()
            && this.customerAddressValidation())

        // cityErrMsg:"",
        // streetErrMsg:"",
        // houseNumberErrMsg:"",
    }


    DatesValidation() {
        // EndDateValidation = true;
        // if ($("#RiderDetails #StartDate").val().length == 0) {
        //     $("#startdate_err").html("* שדה חובה");
        //     EndDateValidation = false;
        // } else {
        //     if (!editShowMode && (IsPastDateValidation(StringToDate($("#RiderDetails #StartDate").val())) || !StringDateValidation($("#RiderDetails #StartDate").val()))) {
        //         EndDateValidation = false;
        //         $("#startdate_err").html("תאריך פתיחה לא תקין");
        //     }
        //     else {
        //         $("#startdate_err").html("");
        //     }
        // }
        // if ($("#RiderDetails #EndDate").val().length == 0) {
        //     $("#enddate_err").html("* שדה חובה");
        //     EndDateValidation = false;
        // } else {
        //     if (!editShowMode && (IsPastDateValidation(StringToDate($("#EndDate").val())) || !StringDateValidation($("#RiderDetails #EndDate").val()))) {
        //         EndDateValidation = false;
        //         $("#enddate_err").html("תאריך סיום לא תקין");
        //     }
        //     else {
        //         $("#enddate_err").html("");
        //     }
        //     return EndDateValidation;
        // }
    }

    isAdmin() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0 
        }
        return false;
    }

    packagesValidation() {

        var valid = true;
        var packages = this.state.riderPackages;
        if (packages && packages.length > 0) {
            if (!this.isAdmin()){
                packages.forEach((p: RiderPackagesWithErrors) => {
                    console.log('p.errors.customerCostErrorMsg', p.errors.customerCostErrorMsg)
                    if (p.errors.customerCostErrorMsg && p.errors.customerCostErrorMsg.length > 0) {
                        valid = false;
                    }
                });
            }
            this.setState({ packagesErrMsg: "" });
        }
        else {
            valid = false;
            this.setState({ packagesErrMsg: "חובה לבחור לפחות חבילה אחת" });
        }

        return valid;
    }

    customerAddressValidation() {
        const cityValid = this.cityValidation();
        const streetValid = this.streetValidation();
        const houseNumberValid = this.houseNumberValidation();
        const mailboxValid = this.mailboxValidation();
       
        if((cityValid && streetValid && houseNumberValid) || (mailboxValid && cityValid)){
            this.setState({ streetErrMsg: "" });
            return true;
        } 
        if(!cityValid){
            this.setState({ cityErrMsg: "* חובה" });
        } 
        if(!streetValid){
            this.setState({ streetErrMsg: "* חובה" });
        }  
        if( !houseNumberValid){
            this.setState({ houseNumberErrMsg: "* חובה" });
        }  
        if( !mailboxValid && (!streetValid || !houseNumberValid)){
            this.setState({ mailboxErrMsg: "* חובה" });
        }
        return false;
    }

    customerDetailsValidation() {


        const identifierValid = this.identifierValidation();
        const firstNameValid = this.firstNameValidation();
        const lastNameValid = this.lastNameValidation();
        // const fullNameValid = this.fullNameValidation();
        const vehicleValid = this.state.vehicleValidation;
        const phoneValid = this.phoneValidation();
        const emailValid = this.emailValidation();
        const birthdateValid = this.birthdateValidation();
        const customerAddressValid = this.customerAddressValidation();



        setTimeout(() => {
            this.setState({ vehicleValidationHandler: new Date().getTime() + "" });
            // this.state.vehicleValidationHandler
        }, 200);
        var errors = "";
        if (!identifierValid) {
            errors += "identifierValid";
        }
        if (!firstNameValid) {
            errors += "firstNameValid";
        }
        if (!lastNameValid) {
            errors += "lastNameValid";
        }
        // if (!fullNameValid) {
        //     errors += "fullNameValid";
        // }
        if (!vehicleValid) {
            errors += "vehicleValid";
        }
        if (!phoneValid) {
            errors += "phoneValid";
        }
        if (!emailValid) {
            errors += "emailValid";
        }
        if (!birthdateValid) {
            errors += "birthdateValid";
        }
        if (!customerAddressValid) {
            errors += "customerAddressValid";
        }


        if (errors.length > 0) {
            //alert(errors);
        }

        return identifierValid && firstNameValid && lastNameValid && vehicleValid && phoneValid && emailValid && birthdateValid && customerAddressValid;

    }

    riderDetailsValidation() {
        // 

        const startDateValid = this.startDateValidation();
        const endDateValid = this.endDateValidation();
        const handlerValid = this.handlerValidation();
        const packagesValidation = this.packagesValidation();
        return startDateValid && endDateValid && handlerValid && packagesValidation;

        // cityErrMsg:"",
        // streetErrMsg:"",
        // houseNumberErrMsg:"",
    }


    identifierValidation() {

        var data = this.state.data;
        if (data && data.customer) {
            if (!data.customer.identifier || data.customer.identifier.length == 0) {
                this.setState({ identifierErrMsg: "* חובה" });
                return false;
            }
            console.log("identifierValidation", data.customer.identifier);
            if (data.customer.identityType == 1 && !this.isValidIsraeliID(data.customer.identifier)) {

                this.setState({ identifierErrMsg: "מס' זהות לא תקין!" });
                return false;
            }
            console.log("identifierValidation correct");
            this.setState({ identifierErrMsg: "" });
            return true;
        }
        return true;
    }

    firstNameValidation() {
        var data = this.state.data;
        const nameRegex = /^[a-zA-Zא-ת\s."'׳״-]+$/;

        if(this.state.isCompany){
            this.setState({ firstNameErrMsg: "" });
            return true;
        }
        if (data && data.customer) {
            if (!data.customer.firstName || data.customer.firstName.length == 0) {
                this.setState({ firstNameErrMsg: "* חובה" });
                return false;
            }else if(!nameRegex.test(data.customer.firstName)){
                this.setState({ firstNameErrMsg:  "שם פרטי לא תקין" });
                return false;
            }
            this.setState({ firstNameErrMsg: "" });
            return true;
        }
        return true;
    }

    lastNameValidation() {
        var data = this.state.data;
        if(this.state.isCompany){
            this.setState({ lastNameErrMsg: "" });
            return true;
        }
        if (data && data.customer) {
            if (data.customer.identityType == 0 || data.customer.identityType == 1) {
                if (!data.customer.lastName || data.customer.lastName.length == 0) {
                    this.setState({ lastNameErrMsg: "* חובה" });
                    return false;
                }else if(!/^[a-zA-Zא-ת\s]*$/.test(data.customer.lastName)){
                    this.setState({ lastNameErrMsg: "שם משפחה לא תקין" });
                    return false;
                }
                this.setState({ lastNameErrMsg: "" });
                return true;
            }
        }
        return true;
    }

    fullNameValidation() {
        var data = this.state.data;
        
        if (data && data.customer) {
            if (data.customer.identityType == 2 || data.customer.identityType == 3) {
                if (!data.customer.fullName || data.customer.fullName.length == 0) {
                    this.setState({ fullNameErrMsg: "* חובה" });
                    return false;
                }
                this.setState({ fullNameErrMsg: "" });
                return true;
            }
        }
        return true;
    }

    phoneValidation() {
        // 
        var data = this.state.data;
        if (data && data.customer && data.customer.customerContactDetails != null &&
            data.customer.customerContactDetails.length > 0 && data.customer.customerContactDetails[0].number && data.customer.customerContactDetails[0].number.length > 0) {
                let phoneNumberData = data.customer.customerContactDetails[0].number.replace(/[-]/g, "");
                console.log('phoneNumberData', phoneNumberData, phoneNumberData.length)
            if ((phoneNumberData.length != 9 && phoneNumberData.length != 10 )
                || isNaN(parseInt(phoneNumberData))) {
                this.setState({ phoneErrMsg: "מס טלפון לא חוקי" });
                return false;
            }

            this.setState({ phoneErrMsg: "" });
            return true;

        }
        else {
            this.setState({ phoneErrMsg: "* חובה" });
            return false;

        }



        return true;
    }

    emailValidation() {
        var data = this.state.data;
        if (data && data.customer && data.customer.customerContactDetails != null &&
            data.customer.customerContactDetails.length > 0 && data.customer.customerContactDetails[0].emailAddress) {
            if (data.customer.customerContactDetails[0].emailAddress.length == 0) {
                this.setState({ emailErrMsg: "* חובה" });
                return false;
            }
            if (!this.EmailValidation(data.customer.customerContactDetails[0].emailAddress)) {
                this.setState({ emailErrMsg: "כתובת מייל לא תקינה" });
                return false;
            }
            this.setState({ emailErrMsg: "" });
            return true;
        }
        return true;
    }

    birthdateValidation() {
        // debugger
        var data = this.state.data;
        let newDate = new Date();
            console.log('data.customer.dateOfBirth-1', data)

        if(this.state.isCompany){
            this.setState({ birthdateErrMsg: "" });
            return true;
        }
        if (data && data.customer) {
            console.log('data.customer.dateOfBirth-2', data.customer.dateOfBirth)
            if (
                data.customer.dateOfBirth === undefined ||
                data.customer.dateOfBirth === null)
            {
                this.setState({ birthdateErrMsg: "* חובה" });
                return false;
            }
            this.setState({ birthdateErrMsg: "" });
            return true;
        }
        return true;
    }

    cityValidation() {
        var data = this.state.data;
        if (data && data.customer && data.customer.customerAddresses && data.customer.customerAddresses.length > 0) {
            if (data.customer.customerAddresses[0].city == null || data.customer.customerAddresses[0].city.length == 0) {
                this.setState({ cityErrMsg: "" });
                return false;
            }
            this.setState({ cityErrMsg: "" });
            return true;
        }
        return true;
    }

    streetValidation() {
        var data = this.state.data;
        if (data && data.customer && data.customer.customerAddresses && data.customer.customerAddresses.length > 0) {
            if (data.customer.customerAddresses[0].street == null || data.customer.customerAddresses[0].street.length == 0) {

                return false;
            }
            return true;
        }
        return true;
    }

    houseNumberValidation() {
        var data = this.state.data;
        if (data && data.customer && data.customer.customerAddresses && data.customer.customerAddresses.length > 0) {
            if (data.customer.customerAddresses[0].houseNumber == null || data.customer.customerAddresses[0].houseNumber == 0) {
                this.setState({ houseNumberErrMsg: "" });
                return false;
            }
            this.setState({ houseNumberErrMsg: "" });
            return true;
        }
        return true;
    }

    mailboxValidation() {
        var data = this.state.data;
        if (data && data.customer && data.customer.customerAddresses && data.customer.customerAddresses.length > 0) {
            if (data.customer.customerAddresses[0].mailbox == null) {
                return false;
            }
            return true;
        }
        return true;
    }

    EmailValidation(email: string) {
        const re = /^\s*[a-z0-9_\+-]+(\.[a-z0-9_\+-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*\.([a-z]{2,4})\s*$/i;

        //var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    GetIsraeliIDValidation(id: string) {
        let strId = String(id).trim();
        if (strId.length > 9) {
            return false;
        }
        if (strId.length < 9) {
            while (strId.length < 9) strId = "0" + strId;
        }
        let counter = 0, rawVal, actualVal;
        for (let i = 0; i < strId.length; i++) {
            rawVal = Number(strId[i]) * ((i % 2) + 1);
            actualVal = rawVal > 9 ? (rawVal - 9) : rawVal;
            counter += actualVal;
        }
        return (counter % 10 === 0);
    }

    endDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.endDate == undefined || data.endDate == null) {
                this.setState({ endDateErrMsg: "* חובה" });
                return false;
            }
            if (data.startDate && data.startDate > data.endDate) {
                this.setState({ endDateErrMsg: "תאריך סיום לא חוקי" });
                return false;
            }
            this.setState({ endDateErrMsg: "" });
            return true;
        }
        return true;
    }

    // startDateValidation() {
    //     var data = this.state.data;
    //     if (data) {
    //         if (data.startDate == undefined || data.startDate == null) {
    //             this.setState({ startDateErrMsg: "* חובה" });
    //             return false;
    //         } else {

    //             if (data.startDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
    //                 this.setState({ startDateErrMsg: "תאריך תחילה לא חוקי" });
    //                 return false;
    //             }
    //             this.setState({ startDateErrMsg: "" });
    //             return true;
    //         }

    //     }
    //     return true;
    // }

    startDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.startDate == undefined || data.startDate == null) {
                this.setState({ startDateErrMsg: "* חובה" });
                return false;
            } else {
                const today = new Date();
                const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
                if (this.isAdmin()) {
                    if (data.startDate.setHours(0, 0, 0, 0) < lastMonthDate.setHours(0, 0, 0, 0)) {
                        this.setState({ startDateErrMsg: "תאריך תחילה לא חוקי" });
                        return false;
                    }
                }
                else {
                    if (data.startDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
                        this.setState({ startDateErrMsg: "תאריך תחילה לא חוקי" });
                        return false;
                    }
                }

                this.setState({ startDateErrMsg: "" });
                return true;
            }

        }
        return true;
    }

    handlerValidation() {
        // 
        var data = this.state.data;
        if (data) {
            if (data.handlerId == undefined || data.handlerId == null) {
                this.setState({ handlerErrMsg: "* חובה" });
                return false;
            }
            this.setState({ handlerErrMsg: "" });
            return true;
        }
        return true;
    }




    onStartDateChanged() {

    }

    handleChange(e: any) { }

    async load() {
        var CarYear = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYear.push(i + "");
        }
        // const model = this.props.rider ? this.props.rider : new RiderModel();// await new SubscribersModel().upsertRider(this.props.id,this.props.actionType);
        if(this.props.renewRider){}
            
        const model = await new SubscribersModel().upsertRider({
            id: this.props.id,
            actionType: this.props.actionType
        });


        model.startDate = null;
        model.endDate = null;
        model.handlerId = null;

        if (model.vehicle == null) {
            model.vehicle = new VehicleDataModel();

        }
        console.log('model', model);
        // console.log('rider', this.props.rider);

        let licenseNumber = '';
        if (model.vehicle && model.vehicle.licenseNumber) {
            licenseNumber = model.vehicle.licenseNumber;

        }

        const loggedUser: any = localStorage.getItem('loggedUser');
        if(loggedUser){
            const user = JSON.parse(loggedUser);
            if(user && user.agentId){
                model.agentId = user.agentId;
            }
        }



        if (this.props.id && this.props.id != '') {
            this.setState({
                editMode: true
            });
        } else {
            if (this.props.customer) {
                model.customer = new CustomerModel(this.props.customer);
            }
            if (this.props.vehicle) {
                model.vehicle = this.props.vehicle;
            }
            if (this.props.rider) {
                model.riderPackages = this.props.rider.riderPackages;
                // console.log('Edit (rider DATA)', this.props.rider)
            }
            // vehicle
            model.customer.dateOfBirth = null;
        }

        if (this.props.customer) {
            model.customer = new CustomerModel(this.props.customer);
        }
        if (this.props.vehicle) {
            model.vehicle = this.props.vehicle;
        }
        if (this.props.rider) {
            model.riderPackages = this.props.rider.riderPackages;
            // console.log('Edit (rider DATA)', this.props.rider)
        }

        if (model && model.customer && model.customer.customerAddresses && model.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            model.customer.customerAddresses.push(address);
        }
        // const citiesData = localStorage.getItem('cities');
        // const cities: any[] = JSON.parse(citiesData as string);
        // console.log('cities', cities);

        const allCities = await this.simulatorModel.getCitiesAutocomplete();
        const { returnDictionary: handlerCustomerList, returnOldDictionary: handlerCustomerOldList } = await this.normalizeHandlers(model.agentId);
        await this.setState({
            data: this.props.renewRider ? await new SubscribersModel().riderRenewRiderSubscriber(this.props.id) : model,
            Gender: await this.simulatorModel.getGenderTypes(),
            IdentityTypes: await this.simulatorModel.getIdentityTypes(),
            VehicleOwnership: await this.simulatorModel.getVehicleOwnership(),
            AuthorizedToDriveItems: await this.simulatorModel.getAuthorizedToDriveItems(),
            InsuranceTypes: await this.simulatorModel.getInsuranceTypes(),
            MaritalStatus: await this.simulatorModel.getMaritalStatus(),
            CarYear: CarYear,
            SelectedTab: 1,
            RiderStatusType: [],
            CustomerHandlers: handlerCustomerList,
            CustomerHandlersOld: handlerCustomerOldList,
            CustomerAgents: await this.normalizeAgents(),
            Branches: await this.buildTreeSelectData(),
            selectedBranch: null,
            licenseNumber: licenseNumber,
            SubscriptionStatuses: [
                {
                    description: 'פעיל',
                    name: 'פעיל',
                    id: 0
                },
                {
                    description: 'מוקפא',
                    name: 'מוקפא',
                    id: 1
                },
                {
                    description: 'ביטול',
                    name: 'ביטול',
                    id: 1
                }
            ],
            packagesListAll2: JSON.parse(JSON.stringify(model.packages)),
            packagesList: this.buildPackagesList(model.packages),
            packagesListAll: this.buildPackagesList(model.packages),

            Branches2: await this.buildBranchesSelectData(),
            allCities: allCities,
            streetList: [],
            citiesAutocomplete: allCities,
            streetAutocomplete: [],
        });
        if(this.props.renewRider){
            const rider = await new SubscribersModel().riderRenewRiderSubscriber(this.props.id);
            let ridersPackagesData = rider.riderPackages

            let dataRider = this.state.data;
            if(dataRider && dataRider.vehicle){
                dataRider.vehicle = new VehicleDataModel(rider.vehicle);
            }

            this.setState({ riderPackages: ridersPackagesData.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) , data: dataRider});
        }
        console.log("packagesListAll2 load", this.state.packagesListAll2);

        let allBranches = null;
        const branchesAndUsersStorage = localStorage.getItem('branchesAndUsers');
        if (!branchesAndUsersStorage) {
            allBranches = await this.simulatorModel.getBranchesAndUsers();
        localStorage.setItem('branchesAndUsers', JSON.stringify(allBranches));
        } else {
            allBranches = JSON.parse(branchesAndUsersStorage);
        }

        // const allBranches = await this.simulatorModel.getBranchesAndUsers();
        console.log('Edit', this.state)
    }


    // async getBranchesTree() {
    //     const branchesTree: any = []; // barnc
    //     const allBranches = await this.simulatorModel.getBranches();
    //     // // const branches = [];
    //     const rootBranches = allBranches ? allBranches.filter((b:any)=> b.parentId === null) : [];
    //     const childBranches =  allBranches ? allBranches.filter((b:any)=> b.parentId !== null) : [];


    //     childBranches.forEach((branch: any) => {
    //         const rootBranch = rootBranches.find((b: any) => b.id === branch.parentId);
    //         if (rootBranch) {
    //             if (rootBranch.children) {
    //                 rootBranch.children.push(branch);
    //             } else {
    //                 rootBranch.children = [branch];
    //             }
    //         } else {
    //             branch.notInTree = true
    //         }
    //         // console.log('rootBranches child', rootBranch)
    //     });

    //     while (allBranches.filter((b:any)=> b.parentId !== null).length>0) {
    //         this.arangeBranchesIntoTree(allBranches);
    //     }
    //     console.log('arangeBranchesIntoTree', allBranches);

    //     return branchesTree;
    // }



    onBranchChange = (e: any) => {
        const branches = this.state.Branches as any;
        if (e.checked && !e.isParent) {
            this.setState({
                selectedBranch: e.value
            });
        } else {
            this.setState({
                selectedBranch: null
            });
        }

        branches.forEach((branch: any) => {
            branch.checked = false;
            if (branch.children) {
                branch.children.forEach((child: any) => {
                    if (child.value === e.value && e.checked) {
                        child.checked = true;
                    } else {
                        child.checked = false
                    }
                });
            }
        });

        this.setState({
            Branches: branches
        })
        console.log('onBranchChange', e)
    }

    onBranchToggle = (e: any) => {
        // console.log('onBranchToggle', e);
    }


    buildTreeSelectData = async () => {
        const allBranches = await this.simulatorModel.getBranches();
        const rootItems = allBranches.filter((b: any) => b.parentId === null);
        const subBranches = allBranches.filter((b: any) => b.parentId != null);
        const branchesTree: any = [];
        rootItems.forEach((bItem: any) => {
            const branch = this.buildBranchData(bItem.id, allBranches);
            branchesTree.push(branch);
        });

        // this.setState({
        //     Branches: branchesTree
        // });
        console.log('branchesTree', subBranches, branchesTree);
        return branchesTree;
    }

    buildBranchData = (branchId: string | null, allBranches: any[]) => {
        const branchData = allBranches.find((b: any) => b.id === branchId);
        const branch: any = {
            label: branchData.name,
            value: branchData.id,
            tagClassName: ''
        }
        const subBranches: any[] = [];
        const items = allBranches.filter((b: any) => b.parentId === branchId);
        items.forEach((item: any) => {
            const branchSub = this.buildBranchData(item.id, allBranches);
            subBranches.push(branchSub);
        });
        branch.children = subBranches;
        if (branchData.users && branchData.users.length > 0) {
            branchData.users.forEach((user: any) => {
                branch.children.push({
                    value: user.value,
                    label: user.text
                })
            })
        }
        return branch;
    }

    onTreeSelectChange = (currentNode: any, selectedNodes: any[]) => {
        console.log(currentNode, selectedNodes);
    }

    async normalizeHandlers(agentId: string) {

        let customerCardHandlers: any[] = []; 
        // const customerCardHandlers = await this.simulatorModel.getCustomerCardHandlers();
        
        const handlerListStorage = localStorage.getItem('handlersList');
        console.log('customerCardHandlers', customerCardHandlers)
        if(handlerListStorage){
            customerCardHandlers = JSON.parse(handlerListStorage);
        }else{
            customerCardHandlers = await this.simulatorModel.getCustomerCardHandlers();
            localStorage.setItem('handlersList', JSON.stringify(customerCardHandlers));
        }

        const customerCarHandlersSorted = customerCardHandlers.sort((a: any, b: any) => {
            if (a.fullName < b.fullName) {
                return -1;
            }
            if (a.fullName > b.fullName) {
                return 1;
            }
            return 0;
        });

        customerCarHandlersSorted['0'] = {
            fullName: 'בחר',
            id: 0,
            status: 0,
        }


        const returnDictionary: any = []
        const returnOldDictionary: any = []

        console.log('customerCardHandlers', customerCarHandlersSorted)
        customerCarHandlersSorted.map((c: User, key: number) => {
            if(c.status == 0  && agentId == c.agentId){
                const item: any = {};
                item.label = c.fullName;
                item.value = c.id;
                item.status = c.status;
                item.agentId = c.agentId;
                returnDictionary[key] = item;
                returnOldDictionary[key] = item;
            } else if(c.status == 0 ){
                let oldItem: any = {};
                oldItem.label = c.fullName;
                oldItem.value = c.id;
                oldItem.status = c.status;
                oldItem.agentId = c.agentId;
                returnOldDictionary[key] = oldItem;
            }
        });

        return {returnDictionary, returnOldDictionary};
    }

    async normalizeAgents() {
        let customerCardHandlers: any[] = [];
        const agentsListStorage = localStorage.getItem('agents');
        if(agentsListStorage){
            customerCardHandlers = JSON.parse(agentsListStorage);
        }else  {
            customerCardHandlers = await this.simulatorModel.getCustomerCardAgents();
        }
        const agents: IDNameDescriptionItem[] = [];
        agents.push({
            description: 'סוכן',
            name: '',
            id: 0
        })
        customerCardHandlers.map((a: any) => {
            agents.push({
                description: a.name,
                name: a.name,
                id: a.id
            })
        });

        return agents as IDNameDescriptionItem[];
    }

    buildPackagesList = (packages: any) => {
        const newList: any = [{
            description: 'בחר',
            name: 'בחר',
            id: 0,
            package: null
        },
        {
            description: 'בחר',
            name: 'בחר',
            id: 0,
            package: null
        }
        ];
        packages.forEach((p: any) => {
            newList.push({
                description: p.name,
                name: p.name,
                id: p.id
            })
        });
        console.log('buildPackagesList', newList)
        return newList as IDNameDescriptionDictionary;
    }

    async normalizeBranches() {
        const branchesList = await this.simulatorModel.getBranches();
        // return customerCardHandlers.map((a: any) => {
        //     return {
        //         description: a.name,
        //         name: a.name,
        //         id: a.id
        //     }
        // }) as IDNameDescriptionItem[];
    }

    setStateData = async (name: string, value: any) => {

        let stateData = this.state.data;
        if (!stateData) {
            stateData = new RiderModel();
        }
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                entry: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            stateData.customer.customerAddresses.push(address);
        }
        if (stateData.customer) {
            if (!stateData.customer.customerContactDetails) {
                stateData.customer.customerContactDetails = [];
            }
            if (stateData.customer.customerContactDetails.length == 0) {
                const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                    id: '00000000-0000-0000-0000-000000000000',
                    emailAddress: '',
                    number: ''
                })
                stateData.customer.customerContactDetails.push(customerContactDetail);
            }
        }
        switch (name) {

            // customer
            case 'identifier': {
                // 
                let data = this.state.data;

                console.log('identifier-data', data)

                if (this.isValidIsraeliID(value) || (this.state.data && this.state.data.customer && this.state.data.customer.identityType && this.state.data.customer.identityType != 1 && value.trim().length === 9)) {
                    const customerData = await this.simulatorModel.getCustomerDetailsById(value);
                    console.log('customerData', customerData);
                    if (customerData && customerData.customer) {

                        if (stateData && stateData.customer) {
                            stateData.customer.id = customerData.customer.id;
                            stateData.customer.identityType = customerData.customer.identityType;
                            stateData.customer.firstName = customerData.customer.firstName;
                            stateData.customer.lastName = customerData.customer.lastName;

                            const bDate = new Date(customerData.customer.dateOfBirth.replace('T', ' '));
                            stateData.customer.dateOfBirth = bDate;

                            stateData.customer.gender = customerData.customer.gender;

                            stateData.customer.customerContactDetails = customerData.customer.customerContactDetails;
                            stateData.customer.customerAddresses = customerData.customer.customerAddresses;
                            this.setState({ vehicles: customerData.customer.vehicles, isInSystem: true ,isCompany: customerData.customer.identityType === 3 || 
                                customerData.customer.identityType === 4 ? true : false});

                            if (customerData.customer.vehicles && customerData.customer.vehicles.length > 0) {
                                var rider = this.state.data;
                                if (rider) {
                                    rider.vehicle = customerData.customer.vehicles[0];
                                    rider.vehicleId = customerData.customer.vehicles[0].id;

                                    this.setState({ data: rider });
                                }
                            }

                            this.customerDetailsValidation();
                        }
                    }
                }
                if (stateData && stateData.customer) {
                    stateData.customer.identifier = value;
                }
                this.identifierValidation();
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'identityType': {
                if (stateData && stateData.customer) {
                    stateData.customer.identityType = value;
                    if (value == 3 || value == 4)//ח.פ.
                    {
                        this.setState({ isCompany: true });
                    }else if(value == 1 || value == 2){
                        this.setState({ isCompany: false });
                    }
                }
                this.identifierValidation();
                break;
            }
            case 'firstName': {
                if (stateData && stateData.customer) {
                    stateData.customer.firstName = value;
                }
                // this.state.data.customer.dateOfBirth
                this.firstNameValidation();
                break;
            }
            case 'lastName': {
                if (stateData && stateData.customer) {
                    stateData.customer.lastName = value;
                }
                // this.state.data.customer.dateOfBirth
                this.lastNameValidation();
                break;
            }

            case 'fullName': {
                if (stateData && stateData.customer) {
                    stateData.customer.fullName = value;
                }
                // this.state.data.customer.dateOfBirth
                this.fullNameValidation();
                break;
            }
            case 'dateOfBirth': {
                if (stateData && stateData.customer) {
                    stateData.customer.dateOfBirth = value as Date;
                }
                // this.state.data.customer.dateOfBirth
                this.birthdateValidation();
                break;
            }
            case 'gender': {
                if (stateData && stateData.customer) {
                    stateData.customer.gender = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'telNumber': {
                if (stateData.customer) {
                    if (!stateData.customer.customerContactDetails) {
                        stateData.customer.customerContactDetails = [];
                    }
                    if (stateData.customer.customerContactDetails.length == 0) {
                        const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                            id: '',
                            emailAddress: '',
                            number: ''
                        })
                        stateData.customer.customerContactDetails.push(customerContactDetail);
                    }
                    stateData.customer.customerContactDetails[0].number = value;
                    this.phoneValidation();
                }

                break;
            }
            case 'emailAddress': {
                if (stateData && stateData.customer && stateData.customer.customerContactDetails && stateData.customer.customerContactDetails.length > 0) {
                    stateData.customer.customerContactDetails[0].emailAddress = value;
                }
                this.emailValidation();
                break;
            }
            // customer address
            case 'city': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].city = value;
                }
                this.cityValidation();
                //this.getPostalCode();
                break;
            }
            case 'street': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].street = value;
                }
                this.customerAddressValidation();
                //this.getPostalCode();
                break;
            }
            case 'houseNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].houseNumber = value;
                }
                this.houseNumberValidation();
                //this.getPostalCode();
                break;
            }
            case 'apartmentNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].apartmentNumber = value;
                }
                break;
            }
            case 'postalCode': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].postalCode = value;
                }
                break;
            }
            case 'entry': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].entry = value;
                }
                break;
            }
            case 'mailbox': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].mailbox = value;
                }
                //this.getPostalCode();
                break;
            }
            // vehicle
            case 'licenseNumber': {
                if (stateData && stateData.vehicle && stateData.vehicle.licenseNumber) {
                    stateData.vehicle.licenseNumber = value;
                }

                break;
            }
            case 'stationUserId': {
                // if (stateData && stateData.stationUserId) {
                //     stateData.stationUserId = value;
                // }
                this.setState({
                    StationUserId: value
                });
                break;
            }
            case 'agentId': {
                let handlerList = this.state.CustomerHandlersOld.filter((h: any) => h.agentId == value);
                (stateData as any)[name] = value
                this.setState({
                    AgentId: value,
                    CustomerHandlers: handlerList
                });
                break;
            }
            case 'startDate': {
                // this.startDateValidation();
                if (stateData && stateData.customer) {
                    var startDate = value as Date;
                    stateData.startDate = startDate;

                    if(stateData.startDate){
                        var month = startDate.getMonth();
                        if (startDate.getDate() > 15) {
                            month++;
                        }
                        var endDate = new Date(startDate.getFullYear() + 1, month, 1);
                        endDate.setDate(endDate.getDate() - 1);
                        stateData.endDate = endDate;

                        this.calcPrices();
                        await this.setState({ data: stateData });
                    }
                    this.startDateValidation();
                    //DatesValidation();

                }
                break;
            }
            case 'endDate': {
                stateData.endDate = value;

                await this.setState({ data: stateData });

                this.endDateValidation();
                this.calcPrices();
                break;
            }
            case 'handlerId': {
                stateData.handlerId = value;
                this.handlerValidation();

                break;
            }
            default:
                (stateData as any)[name] = value
                break;
        }
        this.setState({ data: stateData });
    }

    onCityChange = (city: string) => {
        let stateData = this.state.data;
        const cities = this.state.allCities.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(city) > -1
            }
        );
        this.setState({
            citiesAutocomplete: cities
        });
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            stateData.customer.customerAddresses[0].street = "";
            stateData.customer.customerAddresses[0].houseNumber = 0;
            stateData.customer.customerAddresses[0].postalCode = "";
            this.setState({ data: stateData, streetList: [] });
            console.log('onCityChange', city, this.state.citiesAutocomplete, stateData.customer.customerAddresses[0].city)
        }

        if(city == ""){
            this.setState({streetList: [] ,streetAutocomplete: []});
        }


    }

    onSalesManSelect = (search: string) =>{

        let selected = this.state.CustomerHandlers.find((sm) => sm && sm.label == search);
        if(selected &&  selected.value){
            this.setStateData("handlerId",selected.value)
        } else {
            this.setStateData("handlerId",null)
        }

    }

    onClearSalesManSelect = () =>{
        this.setStateData("handlerId",null)
    }

    onCitySelect = (city: string) => {
        console.log('onCitySelect', city)
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            stateData.customer.customerAddresses[0].street = "";
            stateData.customer.customerAddresses[0].houseNumber = 0;
            stateData.customer.customerAddresses[0].postalCode = "";
            this.setState({ data: stateData });

            const streetAutocomplete = this.simulatorModel.getStreetsAutocomplete(city);
            this.setState({ streetList: streetAutocomplete });

            this.getPostalCode();
        }

        if(city === ""){
            this.setState({streetList: [] ,streetAutocomplete: []});
        }
    }

    onStreetChange = (street: string) => {
        const streets = this.state.streetList.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(street) > -1
            }
        );
        this.setState({
            streetAutocomplete: streets
        });
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            stateData.customer.customerAddresses[0].houseNumber = 0;
            stateData.customer.customerAddresses[0].postalCode = "";
            this.setState({ data: stateData });
            // console.log('onStreetChange', street, this.state.streetAutocomplete, stateData.customer.customerAddresses[0].street)
        }
    }
    onStreetSelect = (street: string) => {
        console.log('onstreetSelect', street)
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            stateData.customer.customerAddresses[0].houseNumber = 0;
            stateData.customer.customerAddresses[0].postalCode = "";
            this.setState({ data: stateData });
        }
        this.getPostalCode();
    }



    getVehicleDetailsKeyPress = async (event: any) => {
        console.log(event.key);
        if (event.key === 'Enter' || event.key === 'Tab') {
            const licenseNumber = event.currentTarget.value;
            this.getVehicleDetails(licenseNumber);
            this.setStateData('licenseNumber', licenseNumber)
        } else {
            // this.setState({licenseNumber: event.target.value});
        }
    }
    isDateValid = (date: Date): boolean => {
        const invalidDate = new Date("0001-01-01T00:00:00");
        return date.getTime() !== invalidDate.getTime();
    };

    calcPrices = () => {
        // 
        var data = this.state.data;
        if (data) {
            var startDate = data.startDate;
            var endDate = data.endDate;
            if (data.updateStartDate && this.isDateValid(data.updateStartDate)) {
                startDate = data.updateStartDate;
                endDate = data.updateEndDate;
            }

            if (startDate && endDate) {
                var days = this.getDaysBetweenDates(startDate, endDate) + 1;


                if (data.riderPackages) {

                    var riderPackages = data.riderPackages
                    for (var i = 0; i < riderPackages.length; i++) {
                        riderPackages[i] = this.calculatePackegePrice(riderPackages[i])

                    }
                    data.riderPackages = riderPackages;

                }

            }
            this.setState({ data: data });
            if (data.riderPackages) { this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
        }


    }

    getDaysBetweenDates = (date1: Date, date2: Date): number => {
        // Calculate the time difference in milliseconds
        const timeDifference = date2.getTime() - date1.getTime();

        // Convert the time difference to days
        const daysDifference = timeDifference / (1000 * 3600 * 24);

        // Return the absolute value to avoid negative numbers
        return Math.abs(daysDifference);
    }

    getVehicleDetails = async (licenseNumber: string) => {

        var stateData = this.state.data;
        if (stateData) {
            stateData.vehicle = new VehicleDataModel();

            await this.setState({
                data: stateData
            })
        }
        var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);

        console.log('getVehicleDetailsByLicenseNumber', data);
        let riderData = this.state.data;
        if (!riderData) {
            riderData = new RiderModel();
        }
        if (!riderData.vehicle) {
            riderData.vehicle = new VehicleDataModel();
        }

        console.log(riderData.vehicle);


        if (data && data.LeviItzhak != null) {
            if (data.LeviItzhak.manufacturer != null) {
                if (!riderData.vehicle.manufacturer) {
                    riderData.vehicle.manufacturer = new ManufacturerModel();
                }
                riderData.vehicle.manufacturer.name = data.LeviItzhak.manufacturer.label;
                riderData.vehicle.manufacturer.id = data.LeviItzhak.manufacturer.val;

            }
            if (data.LeviItzhak.vehicleModel != null) {
                if (!riderData.vehicle.vehicleModel) {
                    riderData.vehicle.vehicleModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleModel.name = data.LeviItzhak.vehicleModel.label;
                riderData.vehicle.vehicleModel.id = data.LeviItzhak.vehicleModel.val;
            }
            if (data.LeviItzhak.vehicleSubModel != null) {
                if (!riderData.vehicle.vehicleSubModel) {
                    riderData.vehicle.vehicleSubModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                riderData.vehicle.vehicleSubModel.name = data.LeviItzhak.vehicleSubModel.label;
                riderData.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
            }

            riderData.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
            riderData.vehicle.carYear = data.LeviItzhak.carYear;
            riderData.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
        }
        this.setState({
            data: riderData
        })
    }

    async onSelectPackage(name: string, value: any) {
        console.log(name, value);
        const riderData = this.state.data;
        var usedPackages = this.state.usedPackages;
        var packagesList = this.state.packagesList;

        if (riderData && riderData.packages) {
            const selectedPackage = riderData.packages.find((p: any) => p.id === value);

            if (selectedPackage) {
                console.log('selectedPackage', selectedPackage);
                //calc prices
                // 

                this.addRiderPackage(this.calculatePackegePrice2(selectedPackage));
                usedPackages.push(selectedPackage);

                var filteredData = filterIDNameDescriptionDictionary(packagesList, (item) =>
                    item.id !== value)
                this.setState({
                    packagesList: filteredData
                });
                if (this.state.data && this.state.data.riderPackages) {
                    { await this.setState({ riderPackages: this.state.data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
                }
            }
        }
        this.packagesValidation();

    }

    calculatePackegePrice(_package: Riders_PackagesModel) {
        if (this.state.data) {
            var startDate = this.state.data.startDate;
            var endDate = this.state.data.endDate;
            if (this.state.data.updateStartDate && this.state.data.updateStartDate.getFullYear() > 1) {
                startDate = this.state.data.updateStartDate;
                endDate = this.state.data.updateEndDate;
            }
            if (startDate && endDate) {
                var days = this.calculateDaysBetweenDates(startDate, endDate) + 1;
                if (this.state.data.packages) {

                    const selectedPackage = this.state.packagesListAll2.find((p: any) => p.id === _package.riderPackageId);
                    if (selectedPackage) {
                        // Create a deep copy of both selectedPackage and _package
                        const selectedPackageCopy = JSON.parse(JSON.stringify(selectedPackage));

                        var RecommendedCost = JSON.parse(JSON.stringify(selectedPackageCopy.recommendedCost as number));
                        if (RecommendedCost) {
                            if (days != 365) {
                                RecommendedCost = this.roundDownNearest10(RecommendedCost / 365 * days);
                            }
                            _package.customerCost = RecommendedCost;

                        }
                    }

                }

            }
        }
        console.log("packagesListAll2 calculatePackegePrice", this.state.packagesListAll2);
        return _package;
    }

    calculatePackegePriceForAgent(agentPrice: number) {

        if (this.state.data) {
            var startDate = this.state.data.startDate;
            var endDate = this.state.data.endDate;
            if (this.state.data.updateStartDate && this.state.data.updateStartDate.getFullYear() > 1) {
                startDate = this.state.data.updateStartDate;
                endDate = this.state.data.updateEndDate;
            }
            if (startDate && endDate) {
                var days = this.calculateDaysBetweenDates(startDate, endDate) + 1;
                // var RecommendedCost = agentPrice;
                // if (RecommendedCost) {
                //     if (days != 365) {
                //         RecommendedCost = this.roundDownNearest10(RecommendedCost / 365 * days);
                //     }
                //     return RecommendedCost;

                // }

                var agentCost = JSON.parse(JSON.stringify(agentPrice as number));
                if (agentCost) {
                    if (days != 365) {
                        agentCost = this.roundDownNearest10(agentCost / 365 * days);
                        console.log('agentCost', agentCost)
                    }
                    return agentCost;
                }
            }


        }
        return agentPrice;

    }

    calculatePackegePrice2(_package: RiderPackageModel) {
        if (this.state.data) {
            var startDate = this.state.data.startDate;
            var endDate = this.state.data.endDate;
            if (this.state.data.updateStartDate && this.state.data.updateStartDate.getFullYear() > 1) {
                startDate = this.state.data.updateStartDate;
                endDate = this.state.data.updateEndDate;
            }
            if (startDate && endDate) {
                var days = this.calculateDaysBetweenDates(startDate, endDate) + 1;
                const selectedPackage = this.state.packagesListAll2.find((p: any) => p.id === _package.id);

                if (selectedPackage) {
                    // Create a deep copy of both selectedPackage and _package
                    const selectedPackageCopy = JSON.parse(JSON.stringify(selectedPackage));
                    var RecommendedCost = JSON.parse(JSON.stringify(selectedPackageCopy.recommendedCost as number));
                    if (RecommendedCost) {
                        if (days != 365) {
                            RecommendedCost = this.roundDownNearest10(RecommendedCost / 365 * days);

                        }
                        _package.recommendedCost = Number(RecommendedCost);
                    }

                    // var agentCost = JSON.parse(JSON.stringify(selectedPackageCopy.agentCost as number));
                    // if (agentCost) {
                    //     if (days != 365) {
                    //         agentCost = this.roundDownNearest10(agentCost / 365 * days);
                    //     }
                    //     _package.agentCost = Number(agentCost);
                    // }
                }
            }
        }
        console.log("packagesListAll2 calculatePackegePrice2", this.state.packagesListAll2);
        return _package;
    }

    calculateDaysBetweenDates(date1: Date, date2: Date): number {
        return Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));


    };

    roundDownNearest10(num: number) {
        return Math.floor(num / 10) * 10;
    }

    addRiderPackage = (selectedPackage: any) => {
        const data = this.state.data ? this.state.data : new RiderModel();
        if (!data.riderPackages) {
            data.riderPackages = [];
        }

        const newRiderPackage = new Riders_PackagesModel();
        newRiderPackage.riderId = data.id;
        newRiderPackage.riderPackageId = selectedPackage.id;
        newRiderPackage.riderPackage = selectedPackage;
        newRiderPackage.agentCost = selectedPackage.agentCost;
        newRiderPackage.customerCost = selectedPackage.recommendedCost;

        data.riderPackages.push(newRiderPackage);

        this.setState({ data: data });

        if (data.riderPackages) { this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
    }

    handleChangeriderPackageCustomerCost = async (packageId: string, e: any) => {
        const data = this.state.data ? this.state.data : new RiderModel();

        var err = "";
        if (data.riderPackages) {

            if (data.packages) {
                const selectedPackage = data.riderPackages.find((p: any) => p.riderPackageId === packageId);
                var packagesList = this.state.packagesList;
                if (selectedPackage) {
                    var cost = parseInt(e.target.value);
                    // if (cost < 150) {
                    //     err = "מחיר נמוך מ150 שח";
                    // }
                    // 
                    if (selectedPackage.agentCost && this.calculatePackegePriceForAgent(selectedPackage.agentCost) > cost) {
                        err = "מחיר נמוך מעלות לסוכן";
                    }
                    selectedPackage.customerCost = e.target.value;
                    data.riderPackages = data.riderPackages
                    this.setState({ data: data });

                    if (data.riderPackages) { this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
                }



            }

            if (data.riderPackages) {
                await this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) });
                if (err.length > 0) {
                    var packages = this.state.riderPackages;
                    if (packages) {
                        const selectedPackage = packages.find((p: RiderPackagesWithErrors) => p.package.riderPackageId === packageId);
                        if (selectedPackage) {
                            selectedPackage.errors.customerCostErrorMsg = err;
                        }
                    }
                    await this.setState({ riderPackages: packages });
                }
            }

        }

    }


    removeRiderPackage = (packageId: string) => {

        console.log('packageId to remove:', packageId);
        const data = this.state.data ? this.state.data : new RiderModel();
        if (data.riderPackages) {

            if (data.packages) {
                const selectedPackage = data.packages.find((p: any) => p.id === packageId);
                var packagesList = this.state.packagesList;
                if (selectedPackage && selectedPackage.id) {
                    packagesList = {
                        ...packagesList,
                        [selectedPackage.id]: {
                            description: selectedPackage.name,
                            name: selectedPackage.name,
                            id: selectedPackage.id
                        }, // Add or update the item in the dictionary
                    };
                    this.setState({ packagesList: packagesList });
                }



            }


            const selectedPackageIndex = data.riderPackages.findIndex((p: any) => p && p.riderPackageId === packageId);
            if (selectedPackageIndex >= 0) {
                // console.log('package to remove:', selectedPackage);
                data.riderPackages.splice(selectedPackageIndex, 1);
                //delete data.riderPackages[selectedPackageIndex];
                this.setState({
                    data: data
                });
                if (data.riderPackages) { this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
            }

            if (data.riderPackages) { this.setState({ riderPackages: data.riderPackages.map((x: Riders_PackagesModel) => new RiderPackagesWithErrors(x)) }); }
        }
    }
    async onHandlerChange(newValue: string, label: any, extra: any) {
        switch (newValue) {
            case '1':
            case '2':
            case '3':
                break;

            default:
                //const branch = this.state.allBranches.find((b: any) => b.id === newValue);
                break;
        }

        const treeDataValue = label[0] ? label[0] : '';
        await this.setState({
            treeDataValue
        });

    };

    async buildBranchesSelectData() {
        const branches = await this.getBranchesTree();
        let branchesSelectData: any[] = [];

        branches.forEach((b: any) => {
            const items = this.buildBranchSelectItems(b, '');
            branchesSelectData = Object.assign(branchesSelectData, items);
        });
        const newList = new IDNameDescriptionDictionary();
        const bList = this.buildSelectDataObject(branchesSelectData);
        newList['0'] = {
            description: 'עמדה',
            name: '',
            id: 0
        }
        bList.forEach((b, index) => {
            if (b && b.id) {
                newList[b.id] = b;
            }
        });
        console.log('newList', newList)
        return newList;
    }

    getBranchesTree = async () => {
        let model = null;
        const branchesAndUsersStorage = localStorage.getItem('branchesAndUsers');
        if (!branchesAndUsersStorage) {
            model = await this.simulatorModel.getBranchesAndUsers();
            localStorage.setItem('branchesAndUsers', JSON.stringify(model));
        } else {
            model = JSON.parse(branchesAndUsersStorage);
        }



        const allBranches = model.branches;
        const branchesTree = allBranches.filter((b: any) => b.parentId === null);
        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = this.getSubBranches(rootBranch, allBranches);
        });

        console.log('branchesTree', branchesTree);

        return branchesTree;
    }

    getSubBranches = (branch: any, branches: any[]) => {
        const subBranches = branches.filter((b: any) => b.parentId === branch.id);
        if (subBranches && subBranches.length > 0) {
            subBranches.forEach((b: any) => {
                b.children = this.getSubBranches(b, branches);
            })
        }
        return subBranches;
    }

    buildBranchSelectItems = (branch: any, branchName: string = '') => {
        const b = {
            label: "VP Accounting",
            tagClassName: "special",
        }
        if (branchName !== '') {
            branchName += '/';
        }
        branchName += branch.name;
        let items: any[] = [];
        if (branch.users && branch.users.length > 0) {
            branch.users.forEach((user: any) => {
                items.push({
                    value: user.value,
                    text: branchName + '/' + user.text
                })
            })
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((child: any) => {
                const childItems = this.buildBranchSelectItems(child, branchName);
                if (childItems && childItems.length > 0) {
                    items = Object.assign(items, childItems);
                }
            })
        }

        return items;
    }

    buildSelectDataObject = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.text,
                name: a.text,
                id: a.value
            }
        }) as IDNameDescriptionItem[];
    }

    isValidIsraeliID = (id: string) => {
        var id = String(id).trim();
        if (id.length > 9 || id.length < 9 || isNaN(parseInt(id))) return false;

        // Pad string with zeros up to 9 digits
        id = id.length < 9 ? ("00000000" + id).slice(-9) : id;

        return Array
            .from(id, Number)
            .reduce((counter, digit, i) => {
                const step = digit * ((i % 2) + 1);
                return counter + (step > 9 ? step - 9 : step);
            }) % 10 === 0;
    }

    VehicleValidation = (isValid: boolean) => {
        this.setState({ vehicleValidation: isValid });

    }

    updateVehicle = (vehicle: VehicleDataModel) => {

        var data = this.state.data;
        if (data) {
            console.log('data.vehicle', data.vehicle)
            if(data.vehicle && data.vehicle.licenseNumber === '' || data.vehicle && data.vehicle.licenseNumber === null){
                this.setState({vehicleValidation: false});
                this.setState({vehicleNumberErrorMsg: "חובה"});
            }
            data.vehicle = vehicle;
            data.vehicleId = vehicle.id;
        }
        this.setState({ data: data });

    }

    updateStationUser = (stationId: string) => {

        var data = this.state.data;
        if (data) {
            data.stationUserId = stationId;
        }
        this.setState({ data: data });

    }
    updateBranch = (vehicle: VehicleDataModel) => {

    }


    toggleInfo = async (packageId: string, flag: boolean) => {
        const data = this.state.data ? this.state.data : new RiderModel();
        if (data.riderPackages) {
            var packages = this.state.riderPackages;
            const selectedPackage = packages.find((p: any) => p && p.package.riderPackageId === packageId);
            if (selectedPackage) {
                selectedPackage.showDescription = flag;
                this.setState({ riderPackages: packages });
            }

        }
    }

    getPostalCode= async ()=>{
        this.setState({postalcodeErrMsg:""})
        this.setState({PostalLoading:true});
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0 
            && stateData.customer.customerAddresses[0].city &&  stateData.customer.customerAddresses[0].city.length>0 
            && stateData.customer.customerAddresses[0].street &&  stateData.customer.customerAddresses[0].street.length>0
            && stateData.customer.customerAddresses[0].houseNumber &&  stateData.customer.customerAddresses[0].houseNumber>0 ) {
        // 
                var postal = await this.simulatorModel.getPostalCode(stateData.customer.customerAddresses[0].city,stateData.customer.customerAddresses[0].street,stateData.customer.customerAddresses[0].houseNumber,stateData.customer.customerAddresses[0].entry , stateData.customer.customerAddresses[0].mailbox)
                if(postal!=null)
                    stateData.customer.customerAddresses[0].postalCode = postal.postalCode;
                else{
                    this.setState({postalcodeErrMsg:"מיקוד לא נמצא"})
                }
                
        } else if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0 
            && stateData.customer.customerAddresses[0].city &&  stateData.customer.customerAddresses[0].city.length>0 
            && stateData.customer.customerAddresses[0].mailbox &&  stateData.customer.customerAddresses[0].mailbox.length >0 ) {
                var postal = await this.simulatorModel.getPostalCode(stateData.customer.customerAddresses[0].city,stateData.customer.customerAddresses[0].street,stateData.customer.customerAddresses[0].houseNumber,stateData.customer.customerAddresses[0].entry, stateData.customer.customerAddresses[0].mailbox)
                if(postal!=null)
                    stateData.customer.customerAddresses[0].postalCode = postal.postalCode;
                else{
                    this.setState({postalcodeErrMsg:"מיקוד לא נמצא"})
                }
            }
        else if(stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0 ){
            stateData.customer.customerAddresses[0].postalCode = "";
        }
        this.setState({ data: stateData });
        this.setState({PostalLoading:false});
        // if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0 
        //     && stateData.customer.customerAddresses[0].city &&  stateData.customer.customerAddresses[0].city.length>0             
        //     && stateData.customer.customerAddresses[0].mailbox &&  stateData.customer.customerAddresses[0].mailbox.length>0 ) {
        //
        //         var postal = await this.simulatorModel.getPostalCode(stateData.customer.customerAddresses[0].city,"",0,"")
                
        //         stateData.customer.customerAddresses[0].postalCode = postal.postalCode;
        //         this.setState({ data: stateData });

            
        // }
        
    } 

    handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
    };
    
    handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.state.isDragging) {
            this.setState({ position: { x: e.clientX - this.state.offset.x, y: e.clientY - this.state.offset.y } });
        }
    };
    
    handleMouseUp = (): void => {
        this.setState({ isDragging: false });
    };

    onClose = () => {
        this.setState({ popupShow: false });
    }


    render() {
        return (<>

        {this.state.popupShow && (
            <MessegePopup 
                message='המידע נשמר בהצלחה'
                statusMessege='success'
                show={this.state.popupShow}
                onClose={this.onClose}
            />
        )}
            {this.state.data != null ? (
                <>





                    <div className="popup-wrapper">
                        <section className="popup-window new-subscriber rtl"
                        style={{ position: 'absolute', top: this.state.position.y, left: this.state.position.x }}
                        >
                            <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div>
                            <div className="popup-content">
                                <div className="popup-header"
                                style={{ cursor: this.state.isDragging ? 'grabbing' : 'grab', }}
                                onMouseDown={this.handleMouseDown}
                                onMouseMove={this.handleMouseMove}
                                onMouseUp={this.handleMouseUp}
                                onMouseLeave={this.handleMouseUp}
                                >
                                    <div className="popup-title">
                                        פרטי מנוי 1
                                    </div>
                                </div>
                                <div className="popup-body">
                                    <div className="tab-contents">
                                        <div className={'tab-content tab-content-1 ' + (this.state.SelectedTab === 1 ? 'selected' : '')}>
                                            <div className='personal-info-title'>פרטים אישיים</div>
                                            <div className="parameter-row">
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            סוג זהות
                                                        </div>
                                                        <div className="value">
                                                            {this.state.IdentityTypes ?
                                                                (
                                                                    <IDNameDescriptionItemSelect
                                                                        OnChange={this.setStateData}
                                                                        Id={"identityType"}
                                                                        Options={this.state.IdentityTypes}
                                                                        Value={
                                                                            this.state.data != null &&
                                                                                this.state.data.customer != null ? this.state.data.customer.identityType : 1}
                                                                    />
                                                                ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            {this.state.isCompany ? "מס' ח.פ" : "מס' זהות"}

                                                        </div>
                                                        <div className="value">
                                                            <input type="text"
                                                                value={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.identifier : ""}
                                                                onChange={(e: any) => { this.setStateData("identifier", e.target.value); }}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.identifierErrMsg}</div>
                                                    </div>

                                                </div>

                                        {this.state.isCompany ? (
                                            <div className="parameter-item">
                                                <div className="field">
                                                    <div className="title">
                                                        שם החברה
                                                    </div>
                                                    <div className="value">
                                                        <input type="text"
                                                            value={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.firstName : ""}
                                                            onChange={(e: any) => this.setStateData("firstName", e.target.value)}
                                                            disabled={this.state.isInSystem}
                                                        />
                                                    </div>
                                                    <div className='error-message2'>{this.state.firstNameErrMsg}</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                             שם פרטי
                                                        </div>
                                                        <div className="value">
                                                            <input type="text"
                                                                value={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.firstName : ""}
                                                                onChange={(e: any) => this.setStateData("firstName", e.target.value)}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.firstNameErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className={this.state.isCompany ? "hide" : "parameter-item"}  >
                                                    <div className="field">
                                                        <div className="title">
                                                            שם משפחה
                                                        </div>
                                                        <div className="value">
                                                            <input type="text"
                                                                value={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.lastName : ""}
                                                                onChange={(e: any) => this.setStateData("lastName", e.target.value)}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.lastNameErrMsg}</div>
                                                    </div>
                                                </div>
                                            </>
                                                )
                                            }
                                            </div>
                                            <div className="parameter-row">
                                                <div className={this.state.isCompany ? "hide" : "parameter-item"} >
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך לידה
                                                        </div>
                                                        <div className="value">
                                                        <CompDatePicker value={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.dateOfBirth : null} 
                                                        onChange={(date: Date) => this.setStateData('dateOfBirth', date)} disabled={this.state.isInSystem}
                                                        />
                                                            {/* <DatePicker
                                                                ref={this.birthDateRef}
                                                                selected={this.state.data != null && this.state.data.customer != null ? this.state.data.customer.dateOfBirth : null}
                                                                onChange={(date: Date) => this.setStateData('dateOfBirth', date)}
                                                                onSelect={(date: Date) => this.setStateData("dateOfBirth", date)}
                                                                dateFormat='dd/MM/yyyy'
                                                                disabled={this.state.isInSystem}
                                                            /> */}
                                                        </div>
                                                        <div className='error-message2'>{this.state.birthdateErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className={this.state.isCompany ? "hide" : "parameter-item"} >
                                                    <div className="field">
                                                        <div className="title">
                                                            מין
                                                        </div>
                                                        <div className="value">
                                                            {this.state.Gender ? (
                                                                <IDNameDescriptionItemSelect
                                                                    OnChange={this.setStateData}
                                                                    Id={"gender"} Options={this.state.Gender}
                                                                    Value={
                                                                        this.state.data != null &&
                                                                            this.state.data.customer != null ? this.state.data.customer.gender : null}
                                                                            Disabled={this.state.isInSystem} />
                                                            ) : ""}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            טלפון
                                                        </div>
                                                        <div className="value">
                                                            <input type="text"
                                                                value={
                                                                    this.state.data != null &&
                                                                        this.state.data.customer != null &&
                                                                        this.state.data.customer.customerContactDetails != null &&
                                                                        this.state.data.customer.customerContactDetails.length > 0 ? this.state.data.customer.customerContactDetails[0].number : ""}
                                                                onChange={(e: any) => this.setStateData("telNumber", e.target.value)}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.phoneErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            דוא"ל
                                                        </div>
                                                        <div className="value">
                                                            <input type="text"
                                                                value={
                                                                    this.state.data != null &&
                                                                        this.state.data.customer != null &&
                                                                        this.state.data.customer.customerContactDetails != null &&
                                                                        this.state.data.customer.customerContactDetails.length > 0 ? this.state.data.customer.customerContactDetails[0].emailAddress : ""}
                                                                onChange={(e: any) => this.setStateData("emailAddress", e.target.value)}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.emailErrMsg}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="parameter-row address-row">
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            עיר
                                                        </div>
                                                        <div className="value">
                                                            {/* <input type="text" 
                                            value={
                                                this.state.data!=null && 
                                                this.state.data.customer!=null && 
                                                this.state.data.customer.customerAddresses!=null && 
                                                this.state.data.customer.customerAddresses.length>0 ? this.state.data.customer.customerAddresses[0].city:""} 
                                                // onChange={(e:any)=>this.handleChange(e)}
                                                onChange={(e:any) =>  this.setStateData("city", e.target.value)}
                                           /> */}

                                                            <Autocomplete Value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].city : ""} Id="cityName"
                                                                ClassName=''
                                                                OnChange={this.onCityChange}
                                                                OnSelect={this.onCitySelect}
                                                                DataList={this.state.citiesAutocomplete}
                                                                Disabled={this.state.isInSystem}
                                                                />
                                                        </div>
                                                        <div className='error-message2'>{this.state.cityErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            רחוב
                                                        </div>
                                                        <div className="value">
                                                            {/* <input type="text" value={
                                            this.state.data!=null && 
                                            this.state.data.customer!=null && 
                                            this.state.data.customer.customerAddresses!=null && 
                                            this.state.data.customer.customerAddresses.length>0 ? this.state.data.customer.customerAddresses[0].street:""} 
                                            onChange={(e:any) =>  this.setStateData("street", e.target.value)}
                                        /> */}
                                                            <Autocomplete Value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].street : ""} Id="streetName"
                                                                ClassName=''
                                                                OnChange={this.onStreetChange}
                                                                OnSelect={this.onStreetSelect}
                                                                DataList={this.state.streetAutocomplete}
                                                                Disabled={this.state.isInSystem}

                                                                />
                                                        </div>
                                                        <div className='error-message2'>{this.state.streetErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מס בית
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 && this.state.data.customer.customerAddresses[0].houseNumber && this.state.data.customer.customerAddresses[0].houseNumber>0 ? this.state.data.customer.customerAddresses[0].houseNumber : ""}
                                                                onChange={(e: any) => this.setStateData("houseNumber", e.target.value)}
                                                                onBlur={(e: any) => this.getPostalCode()}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.houseNumberErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מס דירה
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].apartmentNumber : ""}
                                                                onChange={(e: any) => this.setStateData("apartmentNumber", e.target.value)}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            כניסה
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].entry : ""}
                                                                onChange={(e: any) => this.setStateData("entry", e.target.value)}
                                                                onBlur={(e: any) => this.getPostalCode()}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            ת.ד.
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].mailbox : ""}
                                                                onChange={(e: any) => this.setStateData("mailbox", e.target.value)}
                                                                onBlur={(e: any) => this.getPostalCode()}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מיקוד
                                                        </div>
                                                        <div className="value">
                                                            <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.customer != null &&
                                                                    this.state.data.customer.customerAddresses != null &&
                                                                    this.state.data.customer.customerAddresses.length > 0 ? this.state.data.customer.customerAddresses[0].postalCode : ""}
                                                                onChange={(e: any) => this.setStateData("postalCode", e.target.value)}
                                                                onFocus={(e: any) => this.getPostalCode()}
                                                                onMouseDown={(e: any) => this.getPostalCode()}
                                                                disabled={this.state.isInSystem}
                                                            />
                                                            <img src={require("../assets/images/loading.gif")} className={this.state.PostalLoading ? "loadingGif" : "hide"} />
                                                        </div>
                                                        <div className='error-message2'>{this.state.postalcodeErrMsg}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.data && this.state.data.vehicle ?
                                                <VehicleData vehicle={this.state.data.vehicle} UpdateVehicle={this.updateVehicle} VehicleValidation={this.VehicleValidation} 
                                                vehicles={this.state.vehicles} ValidationMode={this.state.vehicleValidationHandler} />
                                                : ""}


                                        </div>
                                        <div className={'tab-content tab-content-2 ' + (this.state.SelectedTab === 2 ? 'selected' : '')}>
                                            <div className="parameter-row">
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מס' מנוי
                                                        </div>
                                                        <div className="value">
                                                            {this.state.data.subscriberNumber != null ? this.state.data.subscriberNumber : ""}
                                                            {this.state.data.additionNumber != null ? "/"+(this.state.data.additionNumber>10?this.state.data.additionNumber:"0"+this.state.data.additionNumber) : ""}
                                                            {/* <input type="text" value={
                                                                this.state.data != null &&
                                                                    this.state.data.subscriberNumber != null ? this.state.data.subscriberNumber : ""}
                                                                onChange={(e: any) => this.handleChange(e)}
                                                            />
                                                            <input type="text" /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            עמדה
                                                        </div>
                                                        <div>
                                                            <BranchesStationsTree OnSelectStationUser={this.updateStationUser} OnSelectBranch={this.updateBranch} IsBranchCanSelected={false} SelectedStationUsrtId={null} ></BranchesStationsTree>


                                                            {/* <IDNameDescriptionItemSelect
                                                                OnChange={this.setStateData}
                                                                Id={"stationUserId"}
                                                                Value={this.state.StationUserId}
                                                                Options={this.state.Branches2}
                                                            /> */}
                                                            {/* <input type="text" />
                                            <div className="icon small-icon select-arrow pointer"></div> */}
                                                            {/* <DropdownTreeSelect
                                                data={this.state.Branches}
                                                onChange={(e:any) => this.onBranchChange(e)}
                                                onAction={(e:any) => this.onBranchToggle(e)} /> */}
                                                            {/* <TreeSelect mode="radioSelect" data={this.state.Branches} placeholder={'עמדה'} onChange={this.onTreeSelectChange}></TreeSelect> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            סוכן
                                                        </div>
                                                        <div className="value">
                                                            {/* <input type="text" /> */}
                                                            {/* <div className="icon small-icon select-arrow pointer"></div> */}

                                                            {this.state.CustomerAgents ? (
                                                                <IDNameDescriptionItemSelect
                                                                    OnChange={this.setStateData}
                                                                    Id={"agentId"}
                                                                    Options={this.state.CustomerAgents
                                                                    }
                                                                    Value={
                                                                        this.state.data != null &&
                                                                            this.state.data.agentId != null ? this.state.data.agentId : null}
                                                                />
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/* <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מטפל
                                                        </div>
                                                        <div className="value">
                                                            // <input type="text" /> <div className="icon small-icon select-arrow pointer"></div> 
                                                            {this.state.CustomerHandlers ? (
                                                                <IDNameDescriptionItemSelect
                                                                    OnChange={this.setStateData}
                                                                    Id={"handlerId"}
                                                                    Options={this.state.CustomerHandlers
                                                                    }
                                                                    Value={
                                                                        this.state.data != null &&
                                                                            this.state.data.handlerId != null ? this.state.data.handlerId : null}
                                                                />
                                                            ) : ""}
                                                        </div>
                                                        <div className='error-message2'>{this.state.handlerErrMsg}</div>
                                                    </div>
                                                </div> */}

                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            מטפל
                                                        </div>
                                                        <div className="value">
                                                            <CustomSearchHandler
                                                            salesPeopleList={this.state.CustomerHandlers}
                                                            onSalesManSelect={(value: any)=>this.onSalesManSelect(value)}
                                                            selectedSaleManName={this.state.data.handlerId}
                                                            clearValue={()=>this.onClearSalesManSelect()}
                                                            selectId={true}
                                                            />
                                                        </div>
                                                        <div className='error-message2'>{this.state.handlerErrMsg}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="parameter-row three-items">
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך תחילה
                                                        </div>
                                                        <div className="value">

                                                        <CompDatePicker value={ this.state.data != null && this.state.data.startDate != null ? this.state.data.startDate : null} 
                                                        onChange={(e: any) => this.setStateData("startDate", e)} />


                                                            {/* <DatePicker
                                                                ref={this.subscriptionStartDateRef}
                                                                selected={
                                                                    this.state.data != null &&
                                                                        this.state.data.startDate != null ? this.state.data.startDate : null}
                                                                onSelect={(e: any) => this.setStateData("startDate", e)}
                                                                onChange={(e: any) => this.setStateData("startDate", e)}
                                                                dateFormat='dd/MM/yyyy'
                                                            />
                                                            <div className="icon small-icon calendar pointer"></div> */}

                                                        </div>
                                                        <div className='error-message2'>{this.state.startDateErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            תאריך סיום
                                                        </div>
                                                        <div className="value">

                                                        <CompDatePicker value={this.state.data != null && this.state.data.endDate != null ? this.state.data.endDate : null} 
                                                        onChange={(e: any) => this.setStateData("endDate", e)} />

                                                            {/* <DatePicker
                                                                ref={this.subscriptionEndDateRef}
                                                                selected={
                                                                    this.state.data != null &&
                                                                        this.state.data.startDate != null ? this.state.data.endDate : null}
                                                                onSelect={(e: any) => this.setStateData("endDate", e)}
                                                                onChange={(e: any) => this.setStateData("endDate", e)}
                                                                dateFormat='dd/MM/yyyy'
                                                            />
                                                            <div className="icon small-icon calendar pointer"></div> */}
                                                        </div>
                                                        <div className='error-message2'>{this.state.endDateErrMsg}</div>
                                                    </div>
                                                </div>
                                                <div className="parameter-item">
                                                    <div className="field">
                                                        <div className="title">
                                                            סטטוס
                                                        </div>
                                                        <div className="value">
                                                            {this.state.IdentityTypes ?
                                                                (
                                                                    <IDNameDescriptionItemSelect
                                                                        OnChange={this.setStateData}
                                                                        Id={"riderStatusType"}
                                                                        Options={this.state.SubscriptionStatuses}
                                                                        Value={
                                                                            this.state.data != null &&
                                                                                this.state.data.riderStatusType != null ? this.state.data.riderStatusType : null}
                                                                        Disabled={true}
                                                                    />
                                                                ) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <div className="tab-content-title">
                                                    חבילות
                                                </div>
                                                <div className="content-table">
                                                    <div className="table-header">
                                                        <div className="table-row">
                                                            <div className="cell">
                                                                חבילה
                                                            </div>
                                                            <div className="cell">
                                                                מחיר
                                                            </div>
                                                            <div className="cell empty">

                                                            </div>
                                                            <div className="cell actions">
                                                                פעולות
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="table-body">
                                                        {this.state.data != null && this.state.riderPackages != null ? this.state.riderPackages.map((item: any, index: number) => {
                                                            return (
                                                                <div className="table-row">
                                                                    <div className="cell">
                                                                        {item.package.riderPackage.name}
                                                                    </div>
                                                                    <div className="cell">
                                                                        <input type="text" value={
                                                                            item.package.customerCost}
                                                                            onChange={(e: any) => this.handleChangeriderPackageCustomerCost(item.package.riderPackageId, e)}
                                                                        /> ₪
                                                                        <div className='error-message2'>{item.errors.customerCostErrorMsg}</div>
                                                                    </div>
                                                                    <div className="cell empty">

                                                                    </div>
                                                                    <div className="cell actions">
                                                                        <div className="icon document-icon"
                                                                         onMouseOver={(e: any) => this.toggleInfo(item.package.riderPackageId, true)} 
                                                                        // onClick={(e: any) => this.toggleInfo(item.package.riderPackageId)}
                                                                        onMouseOut={(e: any) => this.toggleInfo(item.package.riderPackageId, false)}
                                                                         ></div>
                                                                        <div className={item.showDescription ? "commentStyle" : "hide"} dangerouslySetInnerHTML={{ __html: item.package.riderPackage.comment }}></div>
                                                                        <div className="icon delete-icon pointer click-for-remove" onClick={(e: any) => this.removeRiderPackage(item.package.riderPackageId)}></div>
                                                                    </div>
                                                                </div>

                                                            )
                                                        }) : ""}

                                                    </div>

                                                </div>
                                                <div className="parameter-row">
                                                    <div className="parameter-item wide-item">
                                                        <div className="field">
                                                            <div className="title">
                                                                חבילה
                                                            </div>
                                                            <div className="value">
                                                                {/* <input type="text" />
                                                <div className="icon small-icon select-arrow pointer"></div> */}
                                                                {this.state.packagesList ? (
                                                                    <IDNameDescriptionItemSelect
                                                                        OnChange={(n: string, v: string) => this.onSelectPackage(n, v)}
                                                                        Id={"package"} Options={this.state.packagesList}
                                                                        Value={''}
                                                                    />
                                                                ) : ""}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='error-message2'>{this.state.packagesErrMsg}</div>
                                            <div className={(this.state.riderPackages != null && this.state.riderPackages.length > 1) ? "error-message2" : "hide"} >אנא וודא שלא רכשת כיסויים כפולים</div>

                                            {this.state.popupShow && (<div style={{fontWeight: 'bold',color: 'blue', fontSize: '20px', marginTop: '50px', textAlign: 'center'}}>המידע נשמר בהצלחה</div>)}
                                        </div>
                                        
                                        <div className='error-message'>{this.state.createRiderErr}</div>
                                    </div>
                                </div>
                                <div className="popup-footer">
                                    {this.state.SelectedTab > 1 && (
                                        <button className="button blue prev-button" onClick={(e: any) => this.changeCurrentTab(-1)} >
                                            &lt;&lt; הקודם
                                        </button>
                                    )}
                                    <button className="button white blue-border" onClick={(e: any) => this.closePopup()}>
                                        ביטול
                                    </button>
                                    {this.state.SelectedTab <= 1 && (
                                        <button className="button blue next-button" onClick={(e: any) => this.changeCurrentTab(1)} disabled={this.state.NextTabLoading}>
                                            הבא &gt;&gt;
                                            <img src={require("../assets/images/loading.gif")} className={this.state.NextTabLoading ? "loadingGif" : "hide"} />
                                        </button>

                                    )}
                                   { this.state.SelectedTab === 2 && (
                                    <button className="button white blue-border" onClick={(e: any) => this.saveRider()} disabled={this.state.SaveLoading ? true : false}>
                                        שמור

                                        <img src={require("../assets/images/loading.gif")} className={this.state.SaveLoading ? "loadingGif" : "hide"} />
                                    </button>
                                   )}
                                </div>
                            </div>
                        </section>
                    </div>
                </>
            ) : ""}
        </>



        );
    }
}
